import React from "react";
import Icons from "@visa/vds/icons";
import CookieBanner from "../../components/CookieBanner";
import GlobalAlertProvider from "../../context/GlobalAlertContext";
import MCSFooter from "../../components/MCSFooter";

const MainContent = (props) => {
  return (
    <main className="vds-content" id="content" role="main">
      <GlobalAlertProvider>
        <CookieBanner />
        {props.children}
      </GlobalAlertProvider>
      <Icons />
      <MCSFooter />
    </main>
  );
};

export default MainContent;